module.exports = __webpack_public_path__ + "img/logo.016abdb4.png";